import { Link } from "react-router-dom";

// Vector wordmark logo for EMME SERVICE CAR.
export function Logo({ className = "", onClick }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="logo-home-link"
      className={`group inline-flex items-baseline gap-2 ${className}`}
      aria-label="EMME SERVICE CAR — Home"
    >
      <span className="font-display text-xl font-extrabold tracking-tight text-ice transition-colors group-hover:text-amber">EMME</span>
      <span className="font-display text-xl font-extrabold tracking-tight text-amber">SERVICE CAR</span>
    </Link>
  );
}
